import {
  AppBar,
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Icon,
  IconButton,
  Toolbar,
  Typography,
  Grow
} from '@material-ui/core';
import { AsyncButton } from '../atoms';

const ModalForm = ({
  open,
  onClose,
  onSubmit,
  size = 'sm',
  loading,
  children,
  title,
  btnCancelText = 'Vazgeç',
  btnConfirmText = 'Kaydet',
  confirmBtnDisabled = false,
  ...otherProps
}) => {
  const DialogProps = {
    ...otherProps,
    fullWidth: true,
    maxWidth: size,
    disableEscapeKeyDown: true,
    disableBackdropClick: true,
    TransitionComponent: Grow,
    open,
    onClose
  };

  const handleClick = () => onSubmit && onSubmit();

  return (
    <Dialog {...DialogProps}>
      <AppBar position="static" elevation={0}>
        {/* Title */}
        <Toolbar className="flex justify-between w-full px-16 pr-8" disableGutters>
          <Typography variant="subtitle1" color="inherit">
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <Icon className="text-white">close</Icon>
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Content */}
      <DialogContent dividers className="p-16 pb-8 sm:p-24 sm:pb-12">
        {children}
      </DialogContent>

      {/* Action buttons */}
      <DialogActions className="justify-between px-8 sm:px-16 pb-16">
        <Button variant="contained" color="primary" type="submit" onClick={onClose}>
          {btnCancelText}
        </Button>

        <AsyncButton
          text={btnConfirmText}
          color="secondary"
          loading={loading}
          handleClick={handleClick}
          className=""
          disabled={confirmBtnDisabled}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalForm;
